import type { ShadeCharacteristics } from "@jasper/client-models";
import { useMantineTheme } from "@mantine/core";
import type { FieldValueProps } from "../../types";
import { ShadeCharacteristicsFormV1 } from "./ShadeCharacteristicsFormV1";
import { ShadeCharacteristicsFormV2 } from "./ShadeCharacteristicsFormV2";

export interface ShadeCharacteristicsFormProps extends FieldValueProps<
  Partial<ShadeCharacteristics>
> {
  itemShadeTypes: { value: string; label: string }[];
  itemShades: { value: string; label: string; shadeType?: string }[];
}

export const ShadeCharacteristicsForm = (
  props: ShadeCharacteristicsFormProps
) => {
  const theme = useMantineTheme();

  return theme.other.version === "v2" ? (
    <ShadeCharacteristicsFormV2 {...props} />
  ) : (
    <ShadeCharacteristicsFormV1 {...props} />
  );
};
